import React, { Fragment } from 'react'

import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import isNull from 'lodash/isNull'

import { Form, Checkbox, Text, TextArea, Select } from 'components/forms'
import { notEmpty } from 'helpers/validators'
import { ContentBlock } from 'components/ContentBlock'
import Divider from 'components/Divider'
import Button from 'components/Button'
import styled from 'styled-components'
import { listShops } from 'gql/query'

const TextAreaWrapper = styled.div`
	textarea {
		min-height: 120px;
		margin-bottom: 15px;
	}
`

const Clients = ({ appData, newRecord, data, mutations: { createItem, updateItem } }) => {
	const [t] = useTranslation()
	const isDisable = newRecord ? false : !isNull(data.FA_Id)
	const handleSumbit = vals => {
		if(newRecord) {
			createItem({ ...vals, isCA_Credit: true })
		} else {
			updateItem(vals)
		}
	}

	return (
		<Fragment>
			<ContentBlock>
				<Form
					smartSubmit={!newRecord}
					initialValues={data}
					onSubmit={handleSumbit}
					render={({ formState }) => (
						<Fragment>
							<Row>
								<Col xs>
									<Row style={{ alignItems: 'center' }}>
										<Col xs>
											<Text
												field='clientNumber'
												label={t('credit_client_section.fields.client_number')}
												inline
												disabled={isDisable}
												{...notEmpty()}
												validateOnChange />
											<Checkbox
												field='isActive'
												label={t('credit_client_section.fields.is_active')}
												inline
												disabled={isDisable}/>
										</Col>
									</Row>
									<Row>
										<Col xs>
											<Text
												field='name'
												label={t('credit_client_section.fields.short_name')}
												disabled={isDisable}
												{...notEmpty()}
												validateOnChange />
											{appData.isShopFieldActive &&
												<Select
													label={t('common.fields.shop_affiliation')}
													field='shopId'
													valueField='id'
													labelField='name'
													validate={val => !val && appData.shopAccess ? t('validators.required') : null}
													remoteOptions={{
														query: listShops,
														modifyOptions: (options => {
															return options
																.map(opt => opt.codePrefix ? ({ ...opt, name: `${opt.name} - "${opt.codePrefix}"` }) : opt)
														})
													}}
													isClearable={!appData.shopAccess}
												/>
											}
										</Col>
									</Row>
								</Col>
								<Col xs>
									<Row>
										<Col xs>
											<TextAreaWrapper>
												<TextArea
													field='deliveryAdress'
													label={t('credit_client_section.fields.address')}
													disabled={isDisable}/>
											</TextAreaWrapper>
											<Checkbox
												field='isNoActiveOnClient'
												label={t('credit_client_section.fields.allow_use_only_with_customer_card')}
												disabled={isDisable}/>
										</Col>
									</Row>
								</Col>
							</Row>
							{newRecord &&
								<Fragment>
									<Divider height={40}/>
									<Col type='row'>
										<Button type='submit' status='primary' text={t('common.buttons.create')}/>
									</Col>
								</Fragment>
							}
						</Fragment>
					)}/>
			</ContentBlock>
			{/* <ContentBlock>
				<DataTable
					data={tableDataGenerator(client, 3)}
					columns={client}
					withSearch
					withColFilter
					label='Detaillierte Informationen für gelöschte Einträge'
				/>
				<Divider height={20}/>
			</ContentBlock> */}
		</Fragment>
	)
}

export default Clients
